/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlatPricingDTO
 */
export interface FlatPricingDTO {
    /**
     * 
     * @type {number}
     * @memberof FlatPricingDTO
     */
    priceInCents: number;
}

/**
 * Check if a given object implements the FlatPricingDTO interface.
 */
export function instanceOfFlatPricingDTO(value: object): value is FlatPricingDTO {
    if (!('priceInCents' in value) || value['priceInCents'] === undefined) return false;
    return true;
}

export function FlatPricingDTOFromJSON(json: any): FlatPricingDTO {
    return FlatPricingDTOFromJSONTyped(json, false);
}

export function FlatPricingDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlatPricingDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'priceInCents': json['priceInCents'],
    };
}

export function FlatPricingDTOToJSON(value?: FlatPricingDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'priceInCents': value['priceInCents'],
    };
}

